module.exports = __webpack_public_path__ + "static/img/bg7.d9c7b07.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg7.png
// module id = 5P2B
// module chunks = 1